import { useContext } from 'react';

import { MultiAccurate } from '@lcsc-design/utils/decimal';
import { LayoutContext } from '@lcsc-ui/layouts/baseLayout/provider';
import { buriedPoint } from '@lcsc-ui/utils/buriedPoint';
import { Popover } from 'antd';

import ProductActivity from './productActivity';
import ProductNotice from './productNotice';

import CopyText from '@/components/copyText';
import Image from '@/components/Image';
import { lcBookProvider } from '@/constants';

export default function ProductTop({ data }) {
  const productRecord = data?.productRecord || {};
  const brandVO = data?.brandVO || {};
  const { resourceData } = useContext(LayoutContext);
  const { projectConfigVO } = resourceData;

  const brandPoint = () => {
    buriedPoint({
      pf: 'pc',
      ty: 'click',
      cp: 'product_detail',
      op: 'brand',
    });
  };

  const viewContent = (spuItem) => {
    return (
      <div className="text-center text-[14px] bold text-[#000000]">
        <a href={`${projectConfigVO.lcscItemUrl}/${spuItem.productId}.html?mro=1`} data-spm="txi">
          <Image width={150} height={150} src={spuItem.breviaryImageUrl} alt={spuItem.referredName} />
        </a>
        <p className="lc-text-hiddenblock">{spuItem.referredName}</p>
      </div>
    );
  };

  const OverseaContext = () => {
    const providerIsLCDH = lcBookProvider.includes(productRecord?.provider);

    return (
      <dl>
        {productRecord?.productCodeManufacturer && (
          <div className="flex mt-[16px]">
            <dt className="text-[#69788A] w-[70px]">厂家型号</dt>
            <dd
              className="ml-[30px] text-[#000000] max-w-[350px] lc-text-hidden"
              title={productRecord?.productCodeManufacturer}
            >
              {productRecord?.productCodeManufacturer}
            </dd>
          </div>
        )}
        {(productRecord?.brandName || productRecord?.productGradePlateName) && (
          <div className="flex mt-[16px]">
            <dt className="text-[#69788A] w-[70px]">商品品牌</dt>
            <dd
              className="ml-[30px] text-[#000000] max-w-[350px] lc-text-hidden"
              title={providerIsLCDH ? productRecord?.brandName : productRecord?.productGradePlateName}
            >
              {providerIsLCDH ? productRecord?.brandName : productRecord?.productGradePlateName}
            </dd>
          </div>
        )}
        {!providerIsLCDH && (
          <>
            {(productRecord?.providerAlias || productRecord?.provider) && (
              <div className="flex mt-[16px]">
                <dt className="text-[#69788A] w-[70px]">供应商</dt>
                <dd
                  className="ml-[30px] text-[#000000] max-w-[350px] lc-text-hidden"
                  title={productRecord?.providerAlias || productRecord?.provider}
                >
                  {productRecord?.providerAlias || productRecord?.provider}
                </dd>
              </div>
            )}
            {productRecord?.productCodeProvider && (
              <div className="flex mt-[16px]">
                <dt className="text-[#69788A] w-[70px]">供应商编号</dt>
                <dd
                  className="ml-[30px] text-[#000000] max-w-[350px] lc-text-hidden"
                  title={productRecord?.productCodeProvider}
                >
                  {productRecord?.productCodeProvider}
                </dd>
              </div>
            )}
          </>
        )}
        {productRecord?.placeOfOrigin && (
          <div className="flex mt-[16px]">
            <dt className="text-[#69788A] w-[70px]">产地</dt>
            <dd className="ml-[30px] text-[#000000] max-w-[350px] lc-text-hidden" title={productRecord?.placeOfOrigin}>
              {productRecord?.placeOfOrigin}
            </dd>
          </div>
        )}
        {productRecord?.productRegion && (
          <div className="flex mt-[16px]">
            <dt className="text-[#69788A] w-[70px]">地区</dt>
            <dd className="ml-[30px] text-[#000000] max-w-[350px] lc-text-hidden" title={productRecord?.productRegion}>
              {productRecord?.productRegion}
            </dd>
          </div>
        )}
        {productRecord?.batchNumber && (
          <div className="flex mt-[16px]">
            <dt className="text-[#69788A] w-[70px]">批次</dt>
            <dd className="ml-[30px] text-[#000000] max-w-[350px] lc-text-hidden" title={productRecord?.batchNumber}>
              {productRecord?.batchNumber}
            </dd>
          </div>
        )}
        {productRecord?.selfStandard && (
          <div className="flex mt-[16px]">
            <dt className="text-[#69788A] w-[70px]">封装</dt>
            <CopyText
              tagName="dd"
              title={productRecord?.selfStandard}
              innerText={`${productRecord?.selfStandard}\u200B`}
              copyText={productRecord?.selfStandard}
            />
          </div>
        )}
        {productRecord?.packagingList && productRecord?.packagingList?.length && (
          <div className="flex mt-[16px]">
            <dt className="text-[#69788A] w-[70px]">包装方式</dt>
            <dd
              className="ml-[30px] text-[#000000] max-w-[350px] lc-text-hidden"
              title={productRecord?.packagingList?.join(' / ')}
            >
              {productRecord?.packagingList?.join(' / ')}
            </dd>
          </div>
        )}
        {productRecord?.selfProductIntro && (
          <div className="flex mt-[16px]">
            <dt className="text-[#69788A] w-[70px]">描述</dt>
            <dd
              className="ml-[30px] text-[#000000] max-w-[350px] lc-text-hidden"
              title={productRecord?.selfProductIntro}
            >
              {productRecord?.selfProductIntro}
            </dd>
          </div>
        )}
      </dl>
    );
  };

  const LocalContext = () => {
    return (
      <dl>
        {productRecord?.remark && (
          <div className="flex mt-[16px]">
            <dt className="text-[#69788A] w-[70px]">描述</dt>
            <CopyText
              tagName="dd"
              title={productRecord?.remark}
              innerText={productRecord?.remark}
              isSingleLine={true}
            />
          </div>
        )}
        {(productRecord.brandName || productRecord.productGradePlateName) && (
          <div className="flex mt-[16px]">
            <dt className="text-[#69788A] w-[70px]">品牌名称</dt>
            <dd>
              <a
                className="ml-[30px] text-[#000000] max-w-[350px] lc-text-hidden hover:text-lcBlue"
                href={`${projectConfigVO.lcscListUrl}/brand/${brandVO?.brandId || data?.brandId}.html`}
                target="_blank"
                onClick={brandPoint}
                data-spm="pp"
              >
                {productRecord.brandName || productRecord.productGradePlateName}
              </a>
            </dd>
          </div>
        )}
        {(productRecord.model || productRecord.productModel) && (
          <div className="flex mt-[16px]">
            <dt className="text-[#69788A] w-[70px]">商品型号</dt>
            <CopyText
              tagName="dd"
              title={productRecord.model || productRecord.productModel}
              innerText={productRecord.model || productRecord.productModel}
            />
          </div>
        )}
        {(productRecord.productCode || productRecord.productCodeProvider) && (
          <div className="flex mt-[16px]">
            <dt className="text-[#69788A] w-[70px]">商品编号</dt>
            <CopyText
              tagName="dd"
              title={productRecord.productCode || productRecord.productCodeProvider}
              innerText={productRecord.productCode || productRecord.productCodeProvider}
            />
          </div>
        )}
        {((productRecord?.standard && productRecord?.standard !== '-') ||
          (productRecord?.encapsulationModel && productRecord?.encapsulationModel !== '-')) && (
          <div className="flex mt-[16px]">
            <dt className="text-[#69788A] w-[70px]">商品封装</dt>
            <CopyText
              tagName="dd"
              title={productRecord?.standard || productRecord?.encapsulationModel}
              innerText={`${productRecord?.standard || productRecord?.encapsulationModel}\u200B`}
              copyText={productRecord?.standard || productRecord?.encapsulationModel}
            />
          </div>
        )}
        {(productRecord?.productArrange || productRecord?.packaging) && (
          <div className="flex mt-[16px]">
            <dt className="text-[#69788A] w-[70px]">包装方式</dt>
            <dd
              className="ml-[30px] text-[#000000] max-w-[350px] lc-text-hidden"
              title={productRecord?.productArrange || productRecord?.packaging}
            >
              {productRecord?.productArrange || productRecord?.packaging}
            </dd>
          </div>
        )}
        {productRecord?.productWeight && (
          <div className="flex mt-[16px]">
            <dt className="text-[#69788A] w-[70px]">商品毛重</dt>
            <dd
              className="ml-[30px] text-[#000000] max-w-[350px] lc-text-hidden"
              title={MultiAccurate(productRecord?.productWeight || 0, 1000) + '克(g)'}
            >
              {MultiAccurate(productRecord?.productWeight || 0, 1000) + '克(g)'}
            </dd>
          </div>
        )}
        {productRecord?.designReferenceVOS?.length &&
          productRecord?.designReferenceVOS?.map((designReferenceVO, idx) => {
            return (
              <div className="flex mt-[16px]" key={idx}>
                <dt className="text-[#69788A]">{designReferenceVO?.designReferenceName}</dt>
                <dd className="ml-[20px] items-center" title={designReferenceVO.designReferenceTitle}>
                  <a
                    className=" ml-[5px] hover:text-[#199FE9] text-[#0093E6]"
                    rel="nofollow"
                    href={designReferenceVO.designReferenceUrl}
                    target="_blank"
                    ignore-spm
                  >
                    <span>{designReferenceVO?.designReferenceTitle}</span>
                  </a>
                </dd>
              </div>
            );
          })}
        {data?.isMro && data?.spuProductList && data?.spuProductList?.length > 0 && (
          <div className="flex mt-[16px]">
            <dt className="text-[#69788A] w-[70px]">同系商品</dt>
            <ul className="flex flex-wrap w-[370px] ml-[20px]">
              {data?.spuProductList?.map((spuItem) => {
                return (
                  <Popover key={spuItem?.productId} content={viewContent(spuItem)}>
                    <a href={`${projectConfigVO?.lcscItemUrl}/${spuItem?.productId}.html?mro=1`} data-spm="txl">
                      <li
                        className="w-[115px] h-[34px] text-[14px]
                  text-[#000000] hover:border-[#0093E6] border-solid border-[1px]
                  border-[#DBDDE0] rounded ml-[8px] mb-[10px] p-[4px] flex cursor-pointer"
                      >
                        <Image width={26} height={26} src={spuItem?.breviaryImageUrl} alt="{spuItem?.referredName}" />
                        <span className="lc-text-hidden w-[70px] block ml-[5px]">{spuItem?.referredName}</span>
                      </li>
                    </a>
                  </Popover>
                );
              })}
            </ul>
          </div>
        )}
      </dl>
    );
  };

  return (
    <div className="text-[14px] mb-[20px]">
      <p
        title={
          data?.isMro
            ? productRecord?.productModel || productRecord?.productCodeManufacturer
            : productRecord?.productName
        }
        className="mt-[8px] text-[#000000] w-[460px] lc-text-hidden"
      >
        {data?.isMro
          ? productRecord?.productModel || productRecord?.productCodeManufacturer
          : productRecord?.productName}
      </p>
      {/* 下架商品不展示标签 */}
      {productRecord?.isDisplay !== false && <ProductActivity data={data} />}
      {/* c转p商品，不展示优惠标签 */}
      {productRecord.selfProductCode || (data?.promotionActivityList || []).length <= 0 ? (
        ''
      ) : (
        <ProductNotice data={data} />
      )}
      {productRecord?.isOversea ? <OverseaContext /> : <LocalContext />}
    </div>
  );
}
